module.exports = {"data":{"site":{"siteMetadata":{"title":"Art of PKL"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 102
// module chunks = 60335399758886 114276838955818